import { Component } from 'preact';
import style from './styles/CheckboxInput.scss';
import { CustomInput, FormGroup } from 'reactstrap';
import SlideDownReveal from '../effects/SlideDownReveal';

/**
 * @typedef {Object} CheckboxChangeEvent
 * @property {string}    value     Input value
 * @property {string}    name      Input name
 */

/**
 * @property {string} props.name
 * @property {string} props.label
 * @property {Function} props.onChangeAction
 * @property {boolean} props.required
 * @property {string} props.checked
 */
export default class CheckboxInput extends Component {

	/**
	 * Validates when input looses focus
	 *
	 * @param {Event} event
	 * @this CheckboxInput
	 */
	onChange = (event) => {
		const value = event.target.checked;
		this.props.onChangeAction(this.props.name, {
			value,
			touched: true
		});
	};

	/**
	 * @param {KeyboardEvent} event
	 */
	onKeyDown = (event) => {
		if (event.keyCode === 13 || event.key === 'Enter') {
			this.props.onChangeAction(this.props.name, {
				value: !this.props.value,
				touched: true
			});
		}
	};

	constructor(props) {
		const { onChangeAction } = props;
		if (!(onChangeAction instanceof Function)) {
			new Error('TextInput expects onChangeAction prop to be a defined Function.');
		}
		super(props);
	}

	render({ name, onChange, required, value = false, className = '', label, parentWasValidated, invalidMessage, touched }) {
		const valid = required && value;
		const invalid = required && !value && (touched || parentWasValidated);
		return (
			<FormGroup className={`${style['checkbox-wrapper']} ${className}`}>
				<CustomInput type="checkbox" {...{ name, id: name, label, required, checked: value, valid, invalid, onChange: this.onChange, onKeyDown: this.onKeyDown }} />
				<SlideDownReveal visible={invalid} timeout={300} appear>
					<div className="invalid-feedback">
						{invalidMessage}
					</div>
				</SlideDownReveal>
			</FormGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./components/form/CheckboxInput.js